var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRiderPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d868c;}.cls-2{fill:#729fa4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,20A20,20,0,0,1,20,40a19.74,19.74,0,0,1-5.52-.78A20,20,0,1,1,40,20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.88,33.35a20,20,0,0,1-20.4,5.87,25,25,0,0,1,.9-2.82A41.94,41.94,0,0,1,17.61,32c.05-.16.31-.35.53-.52a.15.15,0,0,0,.05-.06c.31-1.15.87-.53,1.24-.69s.57-.8,1.06-1.43a.26.26,0,0,0,0-.35c-.31-.25-.68-.72-.83-.83-.39-.27-.41-.34-.87-.16-.22.09-2.59.87-2.85.88a1.76,1.76,0,0,1-1.53-.6,8.77,8.77,0,0,1-.77-1.47c-.2-.27-.66-.41-.53-.79,0-.06.08-.13,0-.19a.56.56,0,0,1-.28-.52,1.32,1.32,0,0,0-.11-.71c-.5-.72-.6-.49-1.19-.72-1.19-.47-.22-2.05,0-2.8.19-.6.44-2.31-.18-2.69s-2.34.56-4.27.21c-.81-.15-.22-.43.16-.73.22-.18.43-.39.66-.56a16.61,16.61,0,0,0,1.61-1.39,8.25,8.25,0,0,0,.2-2.25,10.83,10.83,0,0,1,.45-2C13.15,1.33,26,2.38,28.73,10a19,19,0,0,1,1,5.8,10.69,10.69,0,0,1-1.08,4.78,2.64,2.64,0,0,1-1.08,1.28,2.48,2.48,0,0,1-.43.18.12.12,0,0,0-.09.1,4.83,4.83,0,0,0,0,2,.24.24,0,0,0,.26.21.89.89,0,0,1,1,1.1s0,.06,0,.09a.11.11,0,0,0,.12.15c1.26-.08,1.48,1,2,2.08a2.17,2.17,0,0,0,.65.92A11.68,11.68,0,0,1,34.88,33.35Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiderPlaceholder);
export default __webpack_public_path__ + "static/media/riderPlaceholder.99886402e80c69b8f613e3a68afd7115.svg";
export { ForwardRef as ReactComponent };